import type { CircuitBackupFile } from '@multirx/shared/game/circuitBackup.js';
import {
  buildCircuitBackupFile,
  circuitBackupEntryFromSaved,
  circuitBackupFilename,
  parseCircuitBackupPayload,
} from '@multirx/shared/game/circuitBackup.js';
import type { SavedCircuit } from './api.js';

export { circuitBackupEntryFromSaved, buildCircuitBackupFile, parseCircuitBackupPayload };

export function buildBackupFromCircuits(circuits: SavedCircuit[]): CircuitBackupFile {
  return buildCircuitBackupFile(circuits.map((c) => circuitBackupEntryFromSaved(c)));
}

export function downloadCircuitBackupFile(file: CircuitBackupFile): void {
  const blob = new Blob([JSON.stringify(file, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = circuitBackupFilename(new Date(file.exportedAt));
  anchor.click();
  URL.revokeObjectURL(url);
}

export function exportCircuitsToFile(circuits: SavedCircuit[]): void {
  downloadCircuitBackupFile(buildBackupFromCircuits(circuits));
}

export async function readCircuitBackupFromFile(file: File): Promise<CircuitBackupFile> {
  let raw: unknown;
  try {
    raw = JSON.parse(await file.text()) as unknown;
  } catch {
    throw new Error('Fichier JSON invalide');
  }
  const parsed = parseCircuitBackupPayload(raw);
  return buildCircuitBackupFile(parsed.circuits);
}
